import {useState,useEffect} from 'react'
import realtimeDB from '../Utils/api';

const useCostumers = () => 
{
    const [Customers, setCostumers] = useState([]);
    const [CustomersDouble, setCustomersDouble] = useState([]);
    const [CustomersFourfold, setCustomersFourfold] = useState([]);

    useEffect(() => 
    {
       const CostumersRef= realtimeDB.ref("/Customers");

        CostumersRef.on("value",snapshot =>
        {
            let customers=[];
            let double=[];
            let fourfold=[];

            snapshot.forEach(customer =>
            {
                const {status,dinersCount}=customer.val();
                if(status!=="cancelled" && status!=="served")
                {
                    customers.push({id:customer.key,data:customer.val()});

                    if(dinersCount<=2) 
                    {
                        double.push({id:customer.key,data:customer.val()});
                    }
                    else
                    {
                        fourfold.push({id:customer.key,data:customer.val()});
                    }
                } 
            })
            customers = customers.sort((a, b) => (a.data.date > b.data.date ) ? 1 : (a.data.date  === b.data.date ) ? ((a.data.date  > b.data.date ) ? 1 : -1) : -1);
            double= double.sort((a, b) => (a.data.date > b.data.date ) ? 1 : (a.data.date  === b.data.date ) ? ((a.data.date  > b.data.date ) ? 1 : -1) : -1);
            fourfold= fourfold.sort((a, b) => (a.data.date > b.data.date ) ? 1 : (a.data.date  === b.data.date ) ? ((a.data.date  > b.data.date ) ? 1 : -1) : -1);
           
            setCostumers(customers);
            setCustomersDouble(double);
            setCustomersFourfold(fourfold);
        })

       return () => CostumersRef.off();
    }, []);

    return {
        Customers ,
        CustomersDouble,
        CustomersFourfold
    };
}

export default useCostumers
